module.exports = __webpack_public_path__ + "img/hearittypeit.f825f2aa.png";